import { Box, Text } from '@wix/design-system';
import { CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { SwitchProductModule } from '../../../switch-product.module';
export const ProductPrice = _ref => {
  let {
    productDetails
  } = _ref;
  const {
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const formatPrice = SwitchProductModule.SDK.useFormatPrice();
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: "productPrice"
  }, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: CycleUtils.convertCycleDurationToMonths(productDetails.paymentCycle) === 1 ? 'change_plan.change_plan_modal.plan_price_monthly' : 'change_plan.change_plan_modal.plan_price',
    components: [/*#__PURE__*/React.createElement(React.Fragment, null)],
    values: {
      fullPrice: formatPrice(productDetails.totalPrice),
      pricePerMonth: formatPrice(productDetails.pricePerMonth),
      numberOfMonths: CycleUtils.convertCycleDurationToMonths(productDetails.paymentCycle)
    }
  })));
};
//# sourceMappingURL=ProductPrice.js.map